import React, { useEffect, useState } from "react";
import { Table, Tag } from "antd";
import { useSelector } from "react-redux";

const CrmReportTable = ({ printMode = false }) => {
  const { list, loading, filters } = useSelector(
    (state) => state.crmReport
  );

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(1);
  }, [list]);

  const commonColumns = [
    {
      title: "No.",
      width: 70,
      render: (_, __, index) =>
        printMode
          ? index + 1
          : (currentPage - 1) * pageSize + index + 1,
    },
  ];

  let columns = [];

  if (filters.reportType === "source") {
    columns = [
      ...commonColumns,
      {
        title: "Lead Source",
        dataIndex: "source",
      },
      {
        title: "Lead Count",
        dataIndex: "lead_count",
        align: "center",
      },
    ];
  }

  if (filters.reportType === "status") {
    columns = [
      ...commonColumns,
      {
        title: "Lead Status",
        dataIndex: "status",
        render: (value, record) => (
          <Tag color={record.color || "default"}>
            {value || "-"}
          </Tag>
        ),
      },
      {
        title: "Lead Count",
        dataIndex: "lead_count",
        align: "center",
      },
    ];
  }

  if (filters.reportType === "combined") {
    columns = [
      ...commonColumns,
      {
        title: "Source",
        dataIndex: "source",
      },
      {
        title: "Status",
        dataIndex: "status",
      },
      {
        title: "Purpose",
        dataIndex: "purpose",
      },
      {
        title: "Lead Count",
        dataIndex: "lead_count",
        align: "center",
      },
    ];
  }

  return (
    <Table
      rowKey={(record, index) =>
        record.id ||
        `${record.source}-${record.status}-${record.purpose}-${index}`
      }
      columns={columns}
      dataSource={list}
      loading={loading}
      bordered
      scroll={{ x: "max-content" }}
      pagination={
        printMode
          ? false
          : {
              current: currentPage,
              pageSize,
              total: list.length,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50, 100],
              onChange: (page, size) => {
                setCurrentPage(page);
                setPageSize(size);
              },
            }
      }
    />
  );
};

export default CrmReportTable;